export const getBorderRadius = (borderRadius: string | undefined): string => {
  switch (borderRadius) {
    case 'pill':
      return '20px'
    case 'rounded':
      return '8px'
    default:
      return '0px'
  }
}

export const getBorderRadiusAmount = (borderRadius: string | undefined): string => {
  switch (borderRadius) {
    case 'pill':
      return '8px'
    case 'rounded':
      return '8px'
    default:
      return '0px'
  }
}
